export default __webpack_public_path__ + "static/media/carousel2.4451104d.jpg";